import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem("wp-theme") || "light"; }
    catch { return "light"; }
  });

  useEffect(() => {
    try { localStorage.setItem("wp-theme", theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

// ─── Shared token sets ───────────────────────────────────────────────────────
export const tokens = {
  dark: {
    appBg:        "#0D1321",
    navBg:        "#080E1A",
    navBorder:    "#1E293B",
    cardBg:       "#0F1623",
    cardBgHover:  "#141B2D",
    cardBorder:   "#1E293B",
    cardBorderHover: "#2D3748",
    textPrimary:  "#F8FAFC",
    textSecondary:"#64748B",
    textMuted:    "#334155",
    textBody:     "#94A3B8",
    accent:       "#F59E0B",
    accentBg:     "rgba(245,158,11,0.08)",
    accentBorder: "rgba(245,158,11,0.2)",
    tableThead:   "#141B2D",
    tableRow:     "rgba(30,41,59,0.5)",
    tableRowText: "#94A3B8",
    codeBg:       "#1E293B",
    hrColor:      "#1E293B",
    inputBg:      "#1E293B",
    toggleBg:     "#1E293B",
    toggleColor:  "#94A3B8",
  },
  light: {
    appBg:        "#F8FAFC",
    navBg:        "#FFFFFF",
    navBorder:    "#E2E8F0",
    cardBg:       "#FFFFFF",
    cardBgHover:  "#F1F5F9",
    cardBorder:   "#E2E8F0",
    cardBorderHover: "#CBD5E1",
    textPrimary:  "#0F172A",
    textSecondary:"#64748B",
    textMuted:    "#94A3B8",
    textBody:     "#475569",
    accent:       "#D97706",
    accentBg:     "rgba(217,119,6,0.08)",
    accentBorder: "rgba(217,119,6,0.2)",
    tableThead:   "#F1F5F9",
    tableRow:     "rgba(226,232,240,0.6)",
    tableRowText: "#475569",
    codeBg:       "#F1F5F9",
    hrColor:      "#E2E8F0",
    inputBg:      "#F1F5F9",
    toggleBg:     "#F1F5F9",
    toggleColor:  "#64748B",
  },
};
